export default __webpack_public_path__ + "static/media/605.888852a1.png";